export const JOB_LIST_DEFAULTS: Record<string, string> = {
  tab: 'all',
  search_term: '',
  priority_id: 'all',
  job_category_id: 'all',
  page: '1',
};

/** Fixed page size for the Jobs list (no rows-per-page selector — matches Users). */
export const JOBS_PAGE_SIZE = 50;
